import { render, staticRenderFns } from "./NewCopiedFormatEditView.vue?vue&type=template&id=295d1015&scoped=true&"
import script from "./NewCopiedFormatEditView.vue?vue&type=script&lang=ts&"
export * from "./NewCopiedFormatEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295d1015",
  null
  
)

export default component.exports